import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import {
  hotspotActiveImg,
  hotspotInactiveImg,
  hotspotActiveImg2x,
  hotspotInactiveImg2x
} from '../assets/images/hotspots'

const hotspotSize = 40

const styles = {
  hotspotContainer: {
    position: 'absolute',
    zIndex: 1,
    cursor: 'pointer'
  },
  hotspotStyle: {
    width: hotspotSize,
    height: hotspotSize,
    objectFit: 'contain'
  }
}

const hotspotImgMapper = {
  true: hotspotActiveImg,
  false: hotspotInactiveImg
}
const hotspotSrcSetMapper = {
  true: `${hotspotActiveImg2x} 2x`,
  false: `${hotspotInactiveImg2x} 2x`
}

class Hotspot extends Component {
  state = {
    active: this.props.active
  }

  componentWillReceiveProps({ active }) {
    this.setState({ active })
  }

  render() {
    const {
      posX,
      posY,
      onHotspotClick,
      classes: { hotspotStyle, hotspotContainer }
    } = this.props

    const { active } = this.state

    return (
      <div
        className={hotspotContainer}
        style={{
          top: `calc(${posY}% - ${(posY / 100) * hotspotSize}px)`,
          left: `calc(${posX}% - ${(posX / 100) * hotspotSize}px)`
        }}
        onClick={onHotspotClick}
      >
        <img
          className={hotspotStyle}
          alt={`${active ? 'active' : 'inactive'} hotspot`}
          src={hotspotImgMapper[active]}
          srcSet={hotspotSrcSetMapper[active]}
        />
      </div>
    )
  }
}

export default withStyles(styles)(Hotspot)



// WEBPACK FOOTER //
// ./src/components/Hotspot.js